import { z } from 'zod';
import { TDetailedErrorResponse } from 'src_server/trpc/types/error/detailedError';

export const InputSchema = z.object({
    months: z.number()
});

export type ChangeSelfExclusionInput = z.infer<typeof InputSchema>;

export type TSelfExclusionResponseType =
    { responseStatus: 'success'} |
    { responseStatus: 'error'; data: TDetailedErrorResponse }

